import * as React from 'react';
import { Link } from 'react-router-dom';
import TrustWealthLogo from '../components/TrustWealthLogo';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

export default function RegistrationSuccess() {
  return (
    <div className="min-h-screen bg-white">
      <section className="relative pt-20 pb-12 lg:pt-24 lg:pb-16 bg-[#0a1628]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="inline-block">
            <TrustWealthLogo />
          </Link>
          <p className="mt-4 text-primary-400 text-sm font-semibold tracking-widest uppercase">Registration complete</p>
          <h1 className="mt-2 font-serif text-2xl sm:text-3xl font-bold text-white">
            You’re all set
          </h1>
        </div>
      </section>

      <section className="py-12 lg:py-16 bg-slate-50">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm text-center">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-primary-100 rounded-full">
                <CheckCircleIcon className="h-12 w-12 text-primary-600" />
              </div>
            </div>
            <h2 className="text-xl font-bold text-slate-900 mb-2">Registration successful</h2>
            <p className="text-slate-600 text-sm mb-6">
              Thank you for registering with Willowvale Credit Union. Your application is under review. We’ll email you once your account is approved.
            </p>
            <ul className="text-sm text-slate-600 space-y-2 mb-8 text-left">
              <li>• Our team will review your application</li>
              <li>• You’ll get an email about your account status</li>
              <li>• Once approved, sign in with your credentials</li>
            </ul>
            <Link
              to="/"
              className="inline-flex items-center justify-center w-full py-3 px-4 rounded-xl font-semibold text-white bg-primary-500 hover:bg-primary-600 transition-colors"
            >
              Return to home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
